<template>
    <Head title="Applicant Certification"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="Tambahkan Sertifikat"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                        </div>
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Input Sertifikat</h5>
                        </div>
                    </template>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            <Link :href="slotProps.data.credential_url">{{ slotProps.data.name }} - {{ slotProps.data.credential_id }}</Link>
                        </template>
                    </Column>
                    <Column
                        field="issuer"
                        header="Dari Institusi"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Dari Institusi</span>
                            {{ slotProps.data.issuer }}
                        </template>
                    </Column>
                    <Column
                        field="issued_date"
                        header="Dikeluarkan Tanggal"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Dikeluarkan Tanggal</span>
                            {{ slotProps.data.issued_date }}
                        </template>
                    </Column>
                    <Column
                        field="expired_date"
                        header="Berakhir Tanggal"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Expired Date</span>
                            {{ slotProps.data.expired_date }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-pencil"
                                class="p-button-success mr-2"
                                @click="editModel(slotProps.data)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="modelDialog"
                    :style="{ width: '450px' }"
                    header="Detail Sertifikasi"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Name</label>
                        <InputText
                            id="name"
                            v-model.trim="model.name"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.name"
                            >Name perlu diisi.</small
                        >
                    </div>
                     <div class="field">
                        <label for="Issuer">Lembaga Yang Mengeluarkan</label>
                        <InputText
                            id="Issuer"
                            v-model.trim="model.issuer"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.issuer }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.issuer"
                            >Lembaga yang mengeluarkan perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="Issuer">Dikeluarkan Tanggal</label>
                        <Calendar :showIcon="true"
                            :showButtonBar="true"
                            v-model="model.issued_date"
                            :class="{'p-invalid' : submitted && !model.issued_date}"
                            :touchUI="true"
                            dateFormat="yy-mm-dd">
                        </Calendar>
                        <small class="p-invalid" v-if="submitted && !model.issued_date"
                            >Dikeluarkan Tanggal perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="Issuer">Berakhir Tanggal</label>
                        <Calendar :showIcon="true"
                            :showButtonBar="true"
                            v-model="model.expired_date"
                            :class="{'p-invalid' : submitted && !model.expired_date}"
                            :touchUI="true"
                            dateFormat="yy-mm-dd">
                        </Calendar>
                        <small class="p-invalid" v-if="submitted && !model.expired_date"
                            >Berakhir Tanggal perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="credential_id">Nomor Sertifikat (jika ada)</label>
                        <InputText
                            id="credential_id"
                            v-model.trim="model.credential_id"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.credential_id }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.credential_id"
                            >Nomor Sertifikat perlu diisi.</small
                        >
                    </div>
                    <div class="field">
                        <label for="credential_id">Link Sertifikat (jika ada)</label>
                        <InputText
                            id="credential_url"
                            v-model.trim="model.credential_url"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.credential_url }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.credential_url"
                            >Link Sertifikat perlu diisi.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { Head } from "@inertiajs/inertia-vue3";
import { Link } from '@inertiajs/inertia-vue3';
import DataTable from "primevue/datatable";
import Calendar from 'primevue/calendar';
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";

export default {
    components: {
        Head,
        Link,
        DataTable,
        Calendar,
        Column,
        Dialog,
        Button,
        Toolbar,
        Toast,
        InputText,
    },
    props: ['applicant'],
    data() {
        return {
            searchFilter: "",
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            filters: null,
            model: {},
            modelDialog: false,
            models: [],
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
        };
    },
    mounted() {
        this.loading = false;
    },
    methods: {
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        openNew() {
            this.model = {};
            this.submitted = false;
            this.modelDialog = true;
        },
        hideDialog() {
            this.modelDialog = false;
            this.submitted = false;
        },
        saveModel() {
            this.submitted = true;
            this.model.applicant_id = this.applicant.id;
            this.models.push(this.model);

            this.modelDialog = false;
            this.model = {};
        },
        editModel(model) {
            this.model = { ...model };
            this.modelDialog = true;
        },
        confirmDeleteModel(model) {
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
            this.models = this.models.filter(val => val.name !== this.model.name);
            this.deleteModelDialog = false;
            this.model = {};
            this.$toast.add({severity:'success', summary: 'Successful', detail: 'Record Deleted', life: 3000});
        },
        confirmDeleteSelected() {
            this.deleteModelsDialog = true;
        },
        deleteSelectedModels() {
            this.models = this.models.filter(
                (val) => !this.selectedModels.includes(val)
            );
            this.deleteModelsDialog = false;
            this.selectedModels = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Models Deleted",
                life: 3000,
            });
        },
    },
};
</script>
